import { Box, Button, Grid, TextField, Typography } from "@mui/material";
import RootComponents from "../../../components/common/RootComponents";
import styles from "../Candidate.module.css";
import {customTextColor} from "../../../utils/const";

const AddPersonal = () => {
  return (
    // <RootComponents>
      <Box className={styles.candidate_structure}>
        <Typography
          className={styles.add_candidate_heading}
          style={{ color: customTextColor }}
        >
          ADD NEW CANDIDATE FOR PERSONAL USE
        </Typography>
        <Box className={styles.upload_resume_section}>
          <Box style={{ color: customTextColor }}>
            <Typography>Effort less submission just a click</Typography>
            <Typography>50% Extra Result in Recruitment Life</Typography>
          </Box>
          <Button style={{ color: customTextColor }}>Upload Resume</Button>
        </Box>
        <Grid container className={styles.candidate_field_section}>
          <Grid item xs={12} sm={12} md={6} lg={6} sx={{ padding: "10px" }}>
            <TextField
              id="outlined-basic"
              label="Candidate Name"
              variant="outlined"
              sx={{ width: "100%" }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} sx={{ padding: "10px" }}>
            <TextField
              id="outlined-basic"
              label="Mobile No"
              variant="outlined"
              type="number"
              sx={{ width: "100%" }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} sx={{ padding: "10px" }}>
            <TextField
              id="outlined-basic"
              label="E-Mail ID"
              variant="outlined"
              type="email"
              sx={{ width: "100%" }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} sx={{ padding: "10px" }}>
            <TextField
              id="outlined-basic"
              label="LinkedIn Profile"
              variant="outlined"
              type="text"
              sx={{ width: "100%" }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} sx={{ padding: "10px" }}>
            <TextField
              id="outlined-basic"
              label="Current Locations"
              variant="outlined"
              type="text"
              sx={{ width: "100%" }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} sx={{ padding: "10px" }}>
            <TextField
              id="outlined-basic"
              label="Prefer Location"
              variant="outlined"
              type="text"
              sx={{ width: "100%" }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} sx={{ padding: "10px" }}>
            <TextField
              id="outlined-basic"
              label="Visa Status"
              variant="outlined"
              type="text"
              sx={{ width: "100%" }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} sx={{ padding: "10px" }}>
            <TextField
              id="outlined-basic"
              label="Prefer Tax Term"
              variant="outlined"
              type="text"
              sx={{ width: "100%" }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} sx={{ padding: "10px" }}>
            <TextField
              id="outlined-basic"
              label="Current Job Profile"
              variant="outlined"
              type="text"
              sx={{ width: "100%" }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} sx={{ padding: "10px" }}>
            <TextField
              id="outlined-basic"
              label="Total Experience"
              variant="outlined"
              type="text"
              sx={{ width: "100%" }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} sx={{ padding: "10px" }}>
            <TextField
              id="outlined-basic"
              label="Current Company"
              variant="outlined"
              type="text"
              sx={{ width: "100%" }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} sx={{ padding: "10px" }}>
            <TextField
              id="outlined-basic"
              label="Domain Experience"
              variant="outlined"
              type="text"
              sx={{ width: "100%" }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} sx={{ padding: "10px" }}>
            <TextField
              id="outlined-basic"
              label="Highest Qualification"
              variant="outlined"
              type="text"
              sx={{ width: "100%" }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} sx={{ padding: "10px" }}>
            <TextField
              id="outlined-basic"
              label="Passing from University in which year"
              variant="outlined"
              type="number"
              sx={{ width: "100%" }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} sx={{ padding: "10px" }}>
            <TextField
              id="outlined-basic"
              label="Last 4 Digits of SSN No"
              variant="outlined"
              type="number"
              sx={{ width: "100%" }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} sx={{ padding: "10px" }}>
            <TextField
              id="outlined-basic"
              label="Current Rate"
              variant="outlined"
              type="number"
              sx={{ width: "100%" }}
            />
          </Grid>
        </Grid>
        <Typography
          sx={{
            margin: "5px 0",
            fontWeight: "600",
            color: customTextColor,
            padding: "10px",
          }}
        >
          1st References
        </Typography>
        <Grid container>
          <Grid item xs={12} sm={12} md={6} lg={6} sx={{ padding: "10px" }}>
            <TextField
              id="outlined-basic"
              label="Company Name"
              variant="outlined"
              type="text"
              sx={{ width: "100%" }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} sx={{ padding: "10px" }}>
            <TextField
              id="outlined-basic"
              label="Manager’s Name"
              variant="outlined"
              type="text"
              sx={{ width: "100%" }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} sx={{ padding: "10px" }}>
            <TextField
              id="outlined-basic"
              label="Phone No"
              variant="outlined"
              type="number"
              sx={{ width: "100%" }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} sx={{ padding: "10px" }}>
            <TextField
              id="outlined-basic"
              label="E-Mail ID"
              variant="outlined"
              type="email"
              sx={{ width: "100%" }}
            />
          </Grid>
        </Grid>

        <Typography
          sx={{
            margin: "5px 0",
            fontWeight: "600",
            color: customTextColor,
            padding: "10px",
          }}
        >
          2nd References
        </Typography>
        <Grid container>
          <Grid item xs={12} sm={12} md={6} lg={6} sx={{ padding: "10px" }}>
            <TextField
              id="outlined-basic"
              label="Company Name"
              variant="outlined"
              type="text"
              sx={{ width: "100%" }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} sx={{ padding: "10px" }}>
            <TextField
              id="outlined-basic"
              label="Manager’s Name"
              variant="outlined"
              type="text"
              sx={{ width: "100%" }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} sx={{ padding: "10px" }}>
            <TextField
              id="outlined-basic"
              label="Phone No"
              variant="outlined"
              type="number"
              sx={{ width: "100%" }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} sx={{ padding: "10px" }}>
            <TextField
              id="outlined-basic"
              label="E-Mail ID"
              variant="outlined"
              type="email"
              sx={{ width: "100%" }}
            />
          </Grid>
        </Grid>
        <Box className={styles.add_candidate_btns}>
          <Button
            sx={{
              backgroundColor: "#2E7BBF",
              padding: '9px 50px !important',
              '&:hover': {
                backgroundColor: '#2E7BBF'
              }
            }}
          >
            BACK
          </Button>
          <Button
            sx={{
              backgroundColor: "#2EA106",
              padding: '9px 50px !important',
              '&:hover': {
                backgroundColor: '#2EA106'
              }
            }}
          >
            SAVE DETAILS
          </Button>

        </Box>
      </Box>
    // </RootComponents>
  );
};

export default AddPersonal;
